export default "/images/dad75ffdb69b7103429ed477ecf34c97.png";